// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.5 2.5H16.5V6.5H22V21.5H2V6.5H7.5V2.5ZM9.5 6.5H14.5V4.5H9.5V6.5Z"}}]};

const WorkFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'work-filled',
    ref,
    icon: element,
  },
));

WorkFilledIcon.displayName = 'WorkFilledIcon';

export default WorkFilledIcon;
